import moment from "moment";
import i18n from "@/plugins/i18n";
import {isNumber} from "@/utils/validate";

export default {
  formatDate(row, column, cellValue, index) {
    if (cellValue === undefined) {
      return "--";
    }

    if (cellValue.length === 8) {
      return moment(cellValue, "YYYYMMDD").format("YYYY-MM-DD");
    }

    if (cellValue.length === 6) {
      return moment(cellValue, "HHmmss").format("HH:mm:ss");
    }

    if (cellValue.length === 14) {
      return moment(cellValue, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
    }

    if (cellValue.includes("T")) {
      return moment(cellValue, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
    }

    return moment(cellValue, "x").format("YYYY-MM-DD HH:mm:ss");
  },

  formatDateToDate(row, column, cellValue, index) {
    if (cellValue === undefined) {
      return "--";
    }

      return moment(cellValue, "YYYYMMDD").format("YYYY-MM-DD");
  },

  formatBoolean(row, column, cellValue, index) {
    return cellValue ? i18n.t('text.yes') : i18n.t('text.no');
  },

  /**
   * 格式化认证状态
   * @param row
   * @param column
   * @param cellValue
   * @param index
   * @returns {string}
   */
  // formatAuthStatus(row, column, cellValue, index) {
  //   if (cellValue === "000") {
  //     return "认证一致";
  //   } else if (cellValue === "042") {
  //     return "认证不一致";
  //   } else if (cellValue === "043") {
  //     return "认证受限";
  //   } else if (cellValue === "801") {
  //     return "认证失败";
  //   } else if (cellValue === "999") {
  //     return "交易失败";
  //   }
  // },

  /**
   * 分转元
   * @param row
   * @param column
   * @param cellValue
   * @param index
   * @returns {string}
   */

  FenToYuan(row, column, cellValue, index) {
    if (cellValue === 0) {
      return "0";
    }
    if (!cellValue) {
      return "";
    }
    return (cellValue / 100).toFixed(2);
  },

  FenToYuan3(row, column, cellValue, index) {
    if (!cellValue) {
      return "";
    }
    return (cellValue / 100).toFixed(3);
  },

  FenToYuanToThousandth(row, column, cellValue, index) {
    if (cellValue === 0 || cellValue === undefined) {
      return "0";
    }
    if (!cellValue) {
      return "";
    }
    return (cellValue / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  FenToYuan3ToThousandth(row, column, cellValue, index) {
    if (!cellValue) {
      return "";
    }
    return (cellValue / 100).toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  YuanToThousandth(row, column, cellValue, index) {
    if (cellValue === 0 || cellValue === undefined) {
      return "0";
    }
    if (!cellValue) {
      return "";
    }
    return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  formatMerchantType(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('merchantType.00');
    } else if (cellValue === "01") {
      return i18n.t('merchantType.01');
    } else if (cellValue === "02") {
      return i18n.t('merchantType.02');
    }
  },

  formatMerState(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('merchantStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('merchantStatus.01');
    }
  },

  formatProdStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('productionStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('productionStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('productionStatus.02');
    }
  },

  formatCommonStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('commonStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('commonStatus.01');
    }
  },

  formatNewOldCustomer(row, column, cellValue, index) {
    if (cellValue === "00" || cellValue === "0" || !cellValue) {
      return i18n.t('newOldCustomer.00');
    } else if (cellValue === "01") {
      return i18n.t('newOldCustomer.01');
    } else if (cellValue === "02") {
      return i18n.t('newOldCustomer.02');
    }
  },

  formatRiskFlag(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('riskFlag.00');
    } else if (cellValue === "01") {
      return i18n.t('riskFlag.01');
    }
  },

  formatRouteStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('routeStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('routeStatus.01');
    }
  },

  formatOrderStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('orderStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('orderStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('orderStatus.02');
    } else if (cellValue === "03") {
      return i18n.t('orderStatus.03');
    } else if (cellValue === "04") {
      return i18n.t('orderStatus.04');
    } else if (cellValue === "99") {
      return i18n.t('orderStatus.99');
    } else if (cellValue === "06") {
      return i18n.t('orderStatus.06');
    } else if (cellValue === "07") {
      return i18n.t('orderStatus.07');
    }
  },

  formatCardStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('cardStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('cardStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('cardStatus.02');
    } else if (cellValue === "03") {
      return i18n.t('cardStatus.03');
    }
  },

  formatCallBackStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('callbackStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('callbackStatus.01');
    } else {
      return i18n.t('callbackStatus.02');
    }
  },

  formatSettlementStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('settlementStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('settlementStatus.01');
    } else {
      return i18n.t('settlementStatus.others');
    }
  },

  formatTieredBilling(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('tieredBillingStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('tieredBillingStatus.01');
    } else {
      return i18n.t('tieredBillingStatus.others');
    }
  },

  formatNotifyV2(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('notifyV2.00');
    } else if (cellValue === "01") {
      return i18n.t('notifyV2.01');
    } else {
      return i18n.t('text.unknown');
    }
  },

  formatPayType(row, column, cellValue, index) {
    if (cellValue === "01") {
      return "razorpay";
    } else if (cellValue === "02") {
      return "honghuapayout";
    } else if (cellValue === "03") {
      return "honghuapay";
    } else if (cellValue === "04") {
      return "cashfreepay";
    } else if (cellValue === "05") {
      return "flyfishpay";
    } else if (cellValue === "06") {
      return "flyfishpayout";
    } else if (cellValue === "99") {
      return "payment";
    }
  },

  // formatChannelType(row, column, cellValue, index) {
  //   if (cellValue === "01") {
  //     return "razorpay";
  //   } else if (cellValue === "02") {
  //     return "honghuapayout";
  //   } else if (cellValue === "03") {
  //     return "honghuapay";
  //   } else if (cellValue === "04") {
  //     return "cashfreepay";
  //   } else if (cellValue === "05") {
  //     return "flyfishpay";
  //   } else if (cellValue === "06") {
  //     return "flyfishpayout";
  //   } else if (cellValue === "99") {
  //     return "payment";
  //   }
  // },

  // formatDeviceType(row, column, cellValue, index) {
  //   if (cellValue === "01") {
  //     return "湖南农信银";
  //   }
  // },

  // formatBelongType(row, column, cellValue, index) {
  //   if (cellValue === "01") {
  //     return "平台";
  //   } else if (cellValue === "02") {
  //     return "代理商";
  //   } else if (cellValue === "03") {
  //     return "商户";
  //   }
  // },

  formatWithdrawStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('withdrawStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('withdrawStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('withdrawStatus.02');
    } else if (cellValue === "03") {
      return i18n.t('withdrawStatus.03');
    } else if (cellValue === "04") {
      return i18n.t('withdrawStatus.04');
    }
  },

  formatRechargeStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('rechargeStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('rechargeStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('rechargeStatus.02');
    } else if (cellValue === "03") {
      return i18n.t('rechargeStatus.03');
    } else if (cellValue === "04") {
      return i18n.t('rechargeStatus.04');
    }
  },
  formatApprovalStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('approvalStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('approvalStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('approvalStatus.02');
    }
  },
  formatCreditStatus(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('creditStatus.00');
    } else if (cellValue === "01") {
      return i18n.t('creditStatus.01');
    } else if (cellValue === "02") {
      return i18n.t('creditStatus.02');
    }
  },
  formatTransType(row, column, cellValue, index) {
    if (cellValue === "10") {
      return i18n.t('transactionType.10');
    } else if (cellValue === "11") {
      return i18n.t('transactionType.11');
    } else if (cellValue === "12") {
      return i18n.t('transactionType.12');
    } else if (cellValue === "20") {
      return i18n.t('transactionType.20');
    } else if (cellValue === "21") {
      return i18n.t('transactionType.21');
    } else if (cellValue === "22") {
      return i18n.t('transactionType.22');
    } else if (cellValue === "23") {
      return i18n.t('transactionType.23');
    } else if (cellValue === "31") {
      return i18n.t('transactionType.31');
    } else if (cellValue === "30") {
      return i18n.t('transactionType.30');
    } else if (cellValue === "40") {
      return i18n.t('transactionType.40');
    } else if (cellValue === "50") {
      return i18n.t('transactionType.50');
    } else if (cellValue === "51") {
      return i18n.t('transactionType.51');
    } else if (cellValue === "61") {
      return i18n.t('transactionType.61');
    } else if (cellValue === "62") {
      return i18n.t('transactionType.62');
    } else if (cellValue === "33") {
      return i18n.t('transactionType.33');
    } else if (cellValue === "32") {
      return i18n.t('transactionType.32');
    } else if (cellValue === "70") {
      return i18n.t('transactionType.70');
    } else if (cellValue === "71") {
      return i18n.t('transactionType.71');
    }
  },

  formatCardTransType(row, column, cellValue, index) {
    if (cellValue === "10") {
      return i18n.t('cardTransactionType.10');
    } else if (cellValue === "11") {
      return i18n.t('cardTransactionType.11');
    }  else if (cellValue === "20") {
      return i18n.t('cardTransactionType.20');
    }  else if (cellValue === "30") {
      return i18n.t('cardTransactionType.30');
    } else if (cellValue === "31") {
      return i18n.t('cardTransactionType.31');
    }
  },

  formatWithdrawType(row, column, cellValue, index) {
    if (cellValue === "01") {
      return i18n.t('withdrawType.01');
    } else if (cellValue === "02") {
      return i18n.t('withdrawType.02');
    }
  },

  formatNullableString(row, column, cellValue, index) {
    if (cellValue === null || cellValue === undefined || cellValue === '') {
      return "--";
    } else {
      return cellValue;
    }
  },

  formatId(row, column, cellValue, index) {
    if (cellValue === null || cellValue === "0") {
      return "--";
    } else {
      return cellValue;
    }
  },

  formatDisplayField(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('text.accountNumber');
    } else if (cellValue === "01") {
      return i18n.t('text.iban');
    } else {
      return "--";
    }
  },

  formatRechargeWithdraw(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('text.recharge');
    } else if (cellValue === "01") {
      return i18n.t('text.withdrawal');
    } else {
      return "";
    }
  },
  formatRechargeWithdrawRechargeType(row, column, cellValue, index) {
    if (cellValue === "00") {
      return i18n.t('text.rechargeUSDT');
    } else if (cellValue === "01") {
      return i18n.t('text.returnU');
    } else if (cellValue === "02") {
      return i18n.t('text.credit');
    } else if (cellValue === "03") {
      return i18n.t('text.debit');
    } else if (cellValue === "04") {
      return i18n.t('text.payinCredit');
    } else {
      return i18n.t('text.pending');
    }
  },
  formatRechargeEnabledType(row, column, cellValue, index) {
    if (cellValue) {
      return i18n.t('text.enabled');
    }else {
      return i18n.t('text.close');
    }
  },
};
